var _defs, _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew332({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.41px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 2.23,
    y1: 1,
    x2: 2.23,
    y2: 15
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 3.38,
    y1: 1,
    x2: 3.38,
    y2: 15
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 4.54,
    y1: 1,
    x2: 4.54,
    y2: 15
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 5.69,
    y1: 1,
    x2: 5.69,
    y2: 15
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 6.85,
    y1: 1,
    x2: 6.85,
    y2: 15
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 8,
    y1: 1,
    x2: 8,
    y2: 15
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 9.15,
    y1: 1,
    x2: 9.15,
    y2: 15
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 10.31,
    y1: 1,
    x2: 10.31,
    y2: 15
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 11.46,
    y1: 1,
    x2: 11.46,
    y2: 15
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 12.62,
    y1: 1,
    x2: 12.62,
    y2: 15
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 13.77,
    y1: 1,
    x2: 13.77,
    y2: 15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew332);
export default __webpack_public_path__ + "static/media/Symbolpack_New_332.8032da7fde755f1db61b239181934c62.svg";
export { ForwardRef as ReactComponent };